//Margin conventions
var margin = {top: 30, right: 5, bottom: 30, left: 35};

var widther = d3.select(".gia-chart").node().clientWidth;

var width = widther - margin.left - margin.right,
    height = 330 - margin.top - margin.bottom;

//Parses date for correct time format
var parseDate = d3.time.format("%Y").parse; 

//Comma format
format = d3.format("0,000"); 

//Appends the svg to the chart-container div
var svg = d3.select(".gia-chart").append("svg")
	.attr("width", width + margin.left + margin.right)
	.attr("height", height + margin.top + margin.bottom)
	.append("g")
	.attr("transform", "translate(" + margin.left + "," + margin.top + ")");

//Creates the xScale 
var xScale = d3.time.scale()
  .range([0, width]);

//Creates the yScale
var yScale = d3.scale.linear()
  .range([height, 0]);

//Defines the y axis styles
var yAxis = d3.svg.axis()
	.scale(yScale)
  .tickSize(-width)
  .tickPadding(8)
  .ticks(4)
  .tickFormat(function(d) { return format(d) + "%"; })
	.orient("left");

//Defines the y axis styles
var xAxis = d3.svg.axis()
	.scale(xScale)
  .tickPadding(8)
	.orient("bottom")
  .ticks(6)
  .tickFormat(d3.time.format("%Y")); 

//line function convention (feeds an array)
var line = d3.svg.line()
  .defined(function(d) { return d.rate != 0; })
  .x(function(d) { return xScale(d.date); })
  .y(function(d) { return yScale(d.rate); }); 

//area function
//var area = d3.svg.area()
//  .x(function(d) {return xScale(d.date); }) 
//  .y0(height)  
//  .y1(function(d) {return yScale(d.rate); });    

//Loads the data
d3.csv("data/votingRates.csv", ready);

function ready(err, data) {

	if (err) throw "error loading data";

	//FORMAT data
	data.forEach(function(d) {
		d.rate = +d.rate;
    d.date = parseDate(d.date);
	});
	
	//Organizes the data	
  data.sort(function(a,b) { return a.date - b.date; });
  var maxY = d3.max(data, function(d) { return d.rate; });
  var maxX = d3.max(data, function(d) { return d.date; });

  //Nest the data
  var dataByCategory = d3.nest()
    .key(function(d) { return d.category;})
    .entries(data);

  //Mapped to xy
  var plots = dataByCategory.map(function(plots) {
    return data.map(function(d) {
      return {x: +d.date, y: +d.rate, cat: d.category};
    });
  });  

  //Defines the xScale max
  xScale.domain(d3.extent(data, function(d) { return d.date; }));

  //Defines the yScale max
  yScale.domain([0, 80]);

	//Appends the y axis
	var yAxisGroup = svg.append("g")
		.attr("class", "y axis")
		.call(yAxis)
		.selectAll("g")
		.classed("g-baseline", function(d) {return d == 0});

	//Appends the x axis		
	var xAxisGroup = svg.append("g")
		.attr("class", "x axis")
		.attr("transform", "translate(0," + height + ")")
		.call(xAxis);   

  //data join for paths 
  var drawline = svg.selectAll(".cat-path")
    .data(dataByCategory)
    .enter()
    .append("path")
    .attr("class", "cat-path")
    .attr("d", function(d) { return line(d.values) })
    .classed("line1824", function(d) { return d.key == "18 to 24"; })
    .classed("line2544", function(d) { return d.key == "25 to 44"; })
    .classed("line4564", function(d) { return d.key == "45 to 64"; })
    .classed("line65", function(d) { return d.key == "65 and over"; });

  //Adding circle label  
  var labelElements = svg.append("g")
    .attr("class", "fiddly-bits")

  var label = labelElements.selectAll(".g-label-element")
    .data(dataByCategory.filter(function(d) { return d.date == maxX; }))
    .enter().append("g")
    .attr("class", "g-label-element")
    .attr("transform", function(d) { return "translate(" + xScale(d.date) + "," + yScale(d.rate) + ")"; } );

  label.append("circle")
    .attr("r", 3)
    .attr("class", "g-label-circle");

  label.append("text")
    .attr("x", -25)
    .attr("y",-10)
    .text("4.9%")
    .attr("class", "g-label-text");   

//Append labels  
  var label4564 = svg.append("text")
      .text("45 to 64 years")
      .attr("class", "label4564")
      .attr("x", width/7)
      .attr("y", height/12);    

  var label2544 = svg.append("text")
      .text("25 to 44 years")
      .attr("class", "label2544")
      .attr("x", width/2.3)
      .attr("y", height/2.9);  

  var label65 = svg.append("text")
      .text("65 and over")
      .attr("class", "label65")
      .attr("x", width/1.1)
      .attr("y", height/9);  

  var label1824 = svg.append("text")
      .text("18 to 24 years")
      .attr("class", "label1824")
      .attr("x", width/2.2)
      .attr("y", height/1.75);        
      
//RESPONSIVENESS
  d3.select(window).on("resize", resized);

  function resized() {

    //new margin
    var newMargin = {top: 30, right: 5, bottom: 30, left:35};

    var newWidther = d3.select(".gia-chart").node().clientWidth;

    var newWidth = newWidther - newMargin.left - newMargin.right;

    //Change the width of the svg
    d3.select("svg")
      .attr("width", newWidth + newMargin.left + newMargin.right);

    //Change the xScale
    xScale
      .range([0, newWidth]);

    //Update the line
    line = d3.svg.line()
      .defined(function(d) { return d.rate != 0; })
      .x(function(d) { return xScale(d.date); })
      .y(function(d) { return yScale(d.rate); }); 

    d3.selectAll('.cat-path')
      .attr("d", function(d) { return line(d.values) }) 
    
    //Updates xAxis
    d3.selectAll(".x.axis")
         .call(xAxis);     

    //Updates ticks
    xAxis
      .scale(xScale)
      .ticks(6);

    //Updates yAxis
    d3.selectAll(".y.axis")
      .call(yAxis); 

    yAxis
      .tickSize(-newWidth);

    label4564
      .attr("x", newWidth/7); 

    label2544
      .attr("x", newWidth/2.3); 

    label65
      .attr("x", newWidth/1.1);  

    label1824
      .attr("x", newWidth/2.2);     
  };

}